import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import ViewCreateCampaign from "./viewCreateCampaign";
import { ShowStations } from "../../campaign/ShowStations";

class CampaignListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      page: 1,
      limit: 10,
      totalRecords: 0,
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      totalCamp: 0,
      grade: 0,
      showActCampaign: false,
      currentCampaign: "",
      showstationlist: false,
      currentStations: [],
    };
  }

  hideshowstations = (e) => {
    this.setState({ showstationlist: !this.state.showstationlist });
  };

  //Get Campaign Data
  componentDidMount = async () => {
    let { page } = this.state;
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      //   page
    };
    let data1 = await axiosInstnace.post(
      endPoints.getcampaignsbasedondsa,
      data
    );
    let {
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp,
    } = data1.data.data;
    this.setState({
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      grade,
    });
    this.getCampignsData(page);
  };
  handleBack = () => {
    this.setState({
      showActCampaign: false,
    });
  };

  //Fetching Campign Data from backend
  getCampignsData = (page) => {
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      page,
    };
    this.props.getSalesUserCampaign(
      endPoints.getAllCampainsOfUser,
      data,
      CAMPAIGN_DATA_OF_USER
    );
  };

  //set Campaign Data to state
  componentWillReceiveProps = (nextProps) => {
    let { campaignsData } = nextProps;
    this.setState({
      campaignsData:
        campaignsData && campaignsData.allCampaigns
          ? campaignsData.allCampaigns
          : [],
      totalRecords:
        campaignsData && campaignsData.totalRecord
          ? campaignsData.totalRecord
          : 0,
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />{" "}
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                {!this.state.showActCampaign &&
                  campaignsData &&
                  campaignsData.length > 0 && (
                    <div className={`camp_wrapper`}>
                      <div className="running_cap_head">
                        <h2 className="camp_head">RUNNING CAMPAIGNS</h2>
                        <div className="camp_right">
                          <div className="create_camp_btn">
                            <button
                              onClick={() => {
                                window.location.pathname = "/package";
                              }}
                            >
                              CREATE CAMPAIGN
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="camp_listing_wrapper">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Campaign ID</th>
                              <th>Campaign Name</th>
                              <th>Product Category</th>
                              <th>Status</th>
                              <th>Package Type</th>
                              <th>Station</th>
                              <th>
                                Price{" "}
                                <img
                                  src="../../assets/images/rupee-indian.svg"
                                  className="camp_rupee"
                                />
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {campaignsData.map((campaign, index) => {
                              indexNum++;
                              return (
                                <tr key={index}>
                                  <td>{indexNum}</td>
                                  <td>{campaign._id}</td>
                                  <td>{campaign.name}</td>
                                  <td>{campaign.product}</td>
                                  <td>{campaign.status}</td>
                                  <td>{campaign.type}</td>
                                  <td>
                                    {campaign.station.includes(",") ? (
                                      <a
                                        onClick={(e) => {
                                          this.setState({
                                            currentStations: campaign.station.split(
                                              ","
                                            ),
                                            showstationlist: true,
                                          });
                                        }}
                                      >
                                        Multiple (
                                        {campaign.station.split(",").length})
                                      </a>
                                    ) : (
                                      campaign.station
                                    )}
                                  </td>
                                  <td>{campaign.totalCost}</td>
                                  <td style={{display: 'flex'}}>
                                    {campaign.userEmail !==
                                      campaign.sallerId && (
                                      <a
                                        className="view_list"
                                        onClick={() =>
                                          this.goToRoute(
                                            "campaignData",
                                            campaign,
                                            "/tp/viewcampaign"
                                          )
                                        }
                                      >
                                        VIEW
                                      </a>
                                    )}
                                    {campaign.userEmail ===
                                      campaign.sallerId && (
                                      <a
                                        className="view_list"
                                        onClick={() =>
                                          this.setState({
                                            currentCampaign: campaign,
                                            showActCampaign: true,
                                          })
                                        }
                                      >
                                        VIEW
                                      </a>
                                    )}

                                    {campaign.userEmail === campaign.sallerId &&
                                      campaign.pendingAmount > 0 &&
                                      (campaign.status === "Audio Approved" ||
                                        campaign.status === "On-Hold") && !campaign.transactionProof && (
                                          <a
                                            className="view_list"
                                            style={{marginLeft: '25px'}}
                                            onClick={(e) => {
                                              this.setState({
                                                currentCampaign: campaign,
                                                showActCampaign: true,
                                              });
                                            }}
                                          >
                                            Pay{" "}
                                          </a>
                                      )}{" "}

                                    {campaign.userEmail === campaign.sallerId &&
                                      !campaign.payId &&
                                      campaign.status == "Pending" && !campaign.transactionProof && (
                                          <a
                                            className="view_list"
                                            style={{marginLeft: '25px'}}
                                            onClick={() =>
                                              this.setState({
                                                currentCampaign: campaign,
                                                showActCampaign: true,
                                              })
                                            }
                                          >
                                            Pay{" "}
                                          </a>
                                      )}{" "}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <div className="paginationTable">
                          {totalRecords >= 10 && (
                            <Pagination
                              getAllData={this.getCampignsData}
                              totalRecords={totalRecords}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                {!this.state.showActCampaign &&
                  campaignsData &&
                  campaignsData.length == 0 && (
                    <div className={`bookcampaign`}>
                      <div>
                        <img src="../../assets/images/radio.png" />
                      </div>
                      <div className="book_camp_para">
                        <p>It seems like you don't have any campaign's yet</p>
                      </div>
                      <div className="book_camp_btn">
                        <button
                          onClick={() => {
                            window.location.href = "/package";
                          }}
                        >
                          CREATE CAMPAIGN
                        </button>
                      </div>
                    </div>
                  )}
                {this.state.showActCampaign && (
                  <ViewCreateCampaign
                    campaign={this.state.currentCampaign}
                    handleBack={this.handleBack}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.showstationlist && (
          <ShowStations
            stations={this.state.currentStations}
            closeAction={this.hideshowstations}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CampaignListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/CampaignListComp.jsx